/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Categories/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Category from './Category/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Categories({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/Content/Categories"
  
}) {
let selectedCategoriesValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'categories',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<div
  data-testid="Categories.List"
  data-view-path={viewPath}
 style={{'--mt-1-Z1bzBQY': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-2-Z1bzBQY': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(selectedCategoriesValueData) && selectedCategoriesValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="category"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Category(${item?.id ?? item?._id ?? index})`}
      >
<Category
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Category(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }